import React, { useState, useEffect, useCallback } from "react";
import CustomError from "../../../../custom/components/Errors/CustomError";
import Asterisks from "../../../../custom/components/Asterisks/Asterisks";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min";

const MultiSelectDropInput = ({
  label,
  options = [],
  value = [],
  onMultiSelect,
  noDataMessage = "No data available",
  placeholder = "Select options",
  parentClassName = "",
  customError,
  asterisk,
  localkey,
  dropdownId,
  activeDropdown,
  setActiveDropdown,
  loading = true,
  setLoading,
}) => {
  const LOCAL_STORAGE_KEY = "dashboard_details";

  const getStoredSelection = () => {
    const storedData = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

    return storedData?.[localkey] || [];
  };

  const setStoredSelection = (newSelectedItems) => {
    const storedData =
      JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || {};

    storedData[localkey] = newSelectedItems;

    // localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(storedData));
    // const event = new Event("dashboardUpdate");
    // window.dispatchEvent(event);
  };

  const [selectedItems, setSelectedItems] = useState([]);
  const [selectAll, setSelectAll] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [displayText, setDisplayText] = useState("");
  const [searchQuery, setSearchQuery] = useState("");

  const skeletonStyle = {
    backgroundColor: "#f0f0f0",
    borderRadius: "4px",
    position: "relative",
    overflow: "hidden",
    background: "linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)",
    backgroundSize: "200% 100%",
    animation: "shimmer 1.5s infinite linear",
  };
  const styles = {
    dropdownContainer: {
      position: "relative",
      width: "100%",
      marginTop: "30px",
    },
    floatingLabel: {
      position: "absolute",
      top: displayText != "" ? "-8px" : "50%",
      left: "4px",
      transform: displayText != "" ? "translateY(0)" : "translateY(-50%)",
      fontSize: displayText != "" ? "9px" : "12px",
      color: displayText != "" ? "#007bff" : "#6c757d",
      transition: "all 0.3s ease",
      background: "white",
      padding: "0 5px",
      pointerEvents: "none",
      zIndex: 1,
    },
    dropdownToggle: {
      width: "100%",
      padding: "12px",
      textAlign: "left",
      borderRadius: "5px",
      background: "white",
      border: displayText != "" ? "1px solid #007bff" : "1px solid #ced4da",
    },
    dropdownMenu: {
      width: "160%",
      maxHeight: "300px",
      overflowY: "auto",
      whiteSpace: "normal",
      wordWrap: "break-word",
      wordBreak: "break-word",
      position: "absolute",
      left: "-3rem",
      zIndex: 1000,
      boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
      paddingTop: 0,
    },
  };

  // useEffect(() => {
  //   setTimeout(async () => {
  //     const storedSelection = getStoredSelection();
  //     setSelectedItems(storedSelection);

  //     const allSelected =
  //       storedSelection.length === options.length &&
  //       options.every((option) => storedSelection.includes(option.value));

  //     setSelectAll(allSelected);
  //   }, 1000);
  // }, [options]);
  useEffect(() => {
    let timer = setTimeout(() => {
      const storedSelection = getStoredSelection();
      setSelectedItems(storedSelection);

      const allSelected =
        storedSelection.length === options.length &&
        options.every((option) => storedSelection.includes(option.value));

      setSelectAll(allSelected);
    }, 1200);

    return () => clearTimeout(timer);
  }, [options]);
  useEffect(() => {
    if (selectedItems?.length === options?.length && options?.length > 0) {
      setDisplayText("All");
    } else if (selectedItems?.length > 0 && options?.length > 0) {
      const labels = selectedItems?.reduce((acc, item) => {
        const option = options.find((opt) => opt.value == item);
        if (option) acc.push(option.label);
        return acc;
      }, []);

      if (labels.length > 0) {
        setDisplayText(labels.join(", "));
      }
    } else {
      setDisplayText("");
    }
  }, [selectedItems, options]);

  const updateSelection = (newSelectedItems) => {
    setStoredSelection(newSelectedItems);
    setSelectedItems(newSelectedItems);
    onMultiSelect(newSelectedItems);
  };

  const handleSelectAll = useCallback(() => {
    const newSelectedItems = selectAll
      ? []
      : options.map((option) => option.value);
    setSelectAll(!selectAll);
    updateSelection(newSelectedItems);
  }, [selectAll, options]);

  const handleOptionChange = useCallback(
    (optionValue) => {
      setSelectedItems((prevItems) => {
        const isSelected = prevItems.includes(optionValue);
        const updatedItems = isSelected
          ? prevItems.filter((item) => item !== optionValue)
          : [...prevItems, optionValue];
        setSelectAll(updatedItems.length === options.length);
        updateSelection(updatedItems);
        return updatedItems;
      });
    },
    [options]
  );

  const toggleDropdown = () => {
    if (isOpen) {
      setIsOpen(false);
      setActiveDropdown(null);
    } else {
      setIsOpen(true);
      setActiveDropdown(dropdownId);
    }
  };

  useEffect(() => {
    if (activeDropdown !== dropdownId) {
      setIsOpen(false);
    }
  }, [activeDropdown, dropdownId]);

  useEffect(() => {
    if (!isOpen) return;
    const handleClickOutside = (event) => {
      if (!event.target.closest(".custom-dropdown-container")) {
        setIsOpen(false);
        setIsActive(selectedItems.length > 0);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, selectedItems]);
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchQuery.toLowerCase())
  );
  if (loading) {
    return (
      <div
        className={`${parentClassName} custom-dropdown-container`}
        style={styles.dropdownContainer}
      >
        <style>
          {`
            @keyframes shimmer {
              to { background-position: -200% 0; }
            }
          `}
        </style>

        <div
          style={{
            ...skeletonStyle,
            width: "100%",
            height: "40px",
            borderRadius: "5px",
          }}
        ></div>
      </div>
    );
  }

  return (
    <div
      className={`${parentClassName} custom-dropdown-container`}
      style={styles.dropdownContainer}
    >
      <label style={styles.floatingLabel}>
        {label} {asterisk && <Asterisks />}
      </label>
      <button
        className="btn dropdown-toggle d-flex justify-content-between align-items-center"
        type="button"
        onClick={toggleDropdown}
        aria-expanded={isOpen}
        style={styles.dropdownToggle}
      >
        <div
          style={{
            display: "block",
            width: "100%",
            maxWidth: "300px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            color: "black",
          }}
        >
          {displayText}
        </div>
        <span className="ms-2">
          <i className={`bi bi-caret-${isOpen ? "up" : "down"}-fill`}></i>
        </span>
      </button>
      {isOpen && (
        <ul className="dropdown-menu show" style={styles.dropdownMenu}>
          <div
            style={{
              position: "sticky",
              top: "0px",
              background: "white",
              zIndex: 10,
              paddingBottom: "5px",
              borderBottom: "1px solid #ddd",
              paddingTop: "5px",
            }}
          >
            <li className="dropdown-item d-flex justify-content-center">
              <h5 className="font-size-12 mt-0 mb-0">{label}</h5>
            </li>
            <input
              type="text"
              className="form-control m-2"
              placeholder="Search..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              style={{ width: "91%" }}
            />
          </div>
          {filteredOptions.length > 0 ? (
            <>
              {filteredOptions.length > 1 && (
                <>
                  <li onClick={(e) => e.stopPropagation()}>
                    <label
                      className="dropdown-item"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        whiteSpace: "normal",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        padding: "8px",
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={selectAll}
                        onChange={handleSelectAll}
                        className="form-check-input me-2"
                      />{" "}
                      Select All
                    </label>
                  </li>
                  <li>
                    <hr className="dropdown-divider" />
                  </li>
                </>
              )}
              {filteredOptions.map((option) => (
                <li key={option.value} onClick={(e) => e.stopPropagation()}>
                  <label
                    className="dropdown-item"
                    style={{
                      display: "flex",
                      whiteSpace: "normal",
                      wordWrap: "break-word",
                      wordBreak: "break-word",
                      padding: "8px",
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={selectedItems.includes(option.value)}
                      onChange={() => handleOptionChange(option.value)}
                      className="form-check-input me-2"
                    />
                    {option.label}
                  </label>
                </li>
              ))}
            </>
          ) : (
            <li className="dropdown-item text-muted">{noDataMessage}</li>
          )}
        </ul>
      )}
      {customError && <CustomError message={customError} />}
    </div>
  );
};

export default MultiSelectDropInput;
